import React from 'react';
import { useLocation } from 'react-router-dom';
import { SamplesLanguages } from 'types/enums';
import { usePrefixByLocales } from 'hooks/usePrefixByLocales/usePrefixByLocales';
import { i18n } from 'utils/setupTranslations';
import { useGetBasename } from 'hooks/useGetBasename/useGetBasename';

export const useAlternateLinks = () => {
    const localePrefixes = usePrefixByLocales();
    const location = useLocation();
    const { pathname } = location;

    const currentLocalPrefix = localePrefixes[i18n.locale as SamplesLanguages];

    const basename = useGetBasename();
    const basenameWithoutLocale = basename.replace(currentLocalPrefix, '');

    const localeLinks = Object.entries(localePrefixes).map(
        ([locale, prefix]) => {
            const alternateUrl = `${window.location.origin}${basenameWithoutLocale}${prefix}${pathname}`;

            return (
                <link rel="alternate" hrefLang={locale} href={alternateUrl} />
            );
        },
    );

    const xDefaultHref = `${window.location.origin}${basenameWithoutLocale}${pathname}`;

    const xDefaultLink = (
        <link rel="alternate" hrefLang="x-default" href={xDefaultHref} />
    );

    return { localeLinks, xDefaultLink };
};
